import {
  Box,
  Flex,
  VStack,
  HStack,
  Text,
  Button,
  Container,
  Link,
  IconButton,
} from '@chakra-ui/react';
import { FaTwitter, FaLinkedin } from 'react-icons/fa';

export const IntroPage = () => {
  return (
    <Container maxW="container.lg" px={{ base: 4, md: 8 }}>
      <Box
        minH={{ base: '60vh', md: '70vh' }}
        justifyContent="center"
        marginTop="150px"
      >
        <Flex
          direction="column"
          align="center"
          textAlign="center"
          gap={{ base: 6, md: 8 }}
        >
          <Text
            fontSize={{
              base: '7xl',
              sm: '7xl',
              md: '7xl',
              lg: '9xl',
              xl: '9xl',
            }}
            lineHeight="1"
            letterSpacing="0.05em"
            fontFamily={`"Bad Script", cursive`}
          >
            Fernsology
          </Text>

          <Box maxW={{ base: '92%', md: '70%', lg: '80%' }}>
            <Text fontSize={{ base: 'md', md: 'lg' }}>
              Fernsology is a forward-thinking newsletter for anyone who lives
              for technology. It offers insights, practical tips, and creative
              inspiration to help you&nbsp;
              <Text
                as="span"
                textDecoration="underline"
                textDecorationColor="#A67C52"
                textDecorationThickness="1px"
                textUnderlineOffset="5px"
                fontWeight="500"
              >
                explore
              </Text>
              ,{' '}
              <Text
                as="span"
                textDecoration="underline"
                textDecorationColor="#A67C52"
                textDecorationThickness="1px"
                textUnderlineOffset="5px"
                fontWeight="500"
              >
                understand
              </Text>
              , and{' '}
              <Text
                as="span"
                textDecoration="underline"
                textDecorationColor="#A67C52"
                textDecorationThickness="1px"
                textUnderlineOffset="5px"
                fontWeight="500"
              >
                learn
              </Text>{' '}
              in the ever-evolving world of tech.
            </Text>
          </Box>

          <VStack width="100%" align="center">
            <HStack
              flexWrap="wrap"
              justify="center"
              width={{ base: '100%', md: 'auto' }}
              flexDirection={{ base: 'column', sm: 'row' }}
            >
              <Link href="https://fernsology.substack.com/subscribe">
                <Button
                  width={{ base: '100%', sm: 'auto' }}
                  size={{ base: 'md', md: 'lg' }}
                  px={{ base: 4, sm: 6, md: 8 }}
                  fontSize={{ base: 'sm', sm: 'md', md: 'lg' }}
                  bg="#d6bfc0"
                  color="#444444"
                >
                  Subscribe to the newsletter
                </Button>
              </Link>
            </HStack>
            <HStack>
              <Link href="https://twitter.com/fernsology">
                <IconButton aria-label="Twitter" bg="#eaeaea">
                  <FaTwitter color="#444444" />
                </IconButton>
              </Link>

              <Link href="https://linkedin.com/company/fernsology">
                <IconButton aria-label="LinkedIn" bg="#eaeaea">
                  <FaLinkedin color="#444444" />
                </IconButton>
              </Link>
            </HStack>
          </VStack>
        </Flex>
      </Box>
    </Container>
  );
};
